export default __webpack_public_path__ + "static/media/landscape4.c7cc249b.JPG";